/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Injector, Input } from '@angular/core';
import { type ColumnDef, type TableConfig, I18nService, TableAbstract, UNPLACEHOLDER, UtilService } from '@dm/core';
import { type SelectOption } from '@dm/core/types';
import { SWITCH } from 'app/config';
import { HostsStrService } from 'app/feature/service/block-service/hosts/hosts-str.service';

@Component({
    selector: 'app-member-initiators-table',
    templateUrl: './member-initiators-table.component.html',
})
export class MemberInitiatorsTableComponent extends TableAbstract<any> implements OnInit {
    @Input() data;
    @Input() loading = false;
    tableConfig: TableConfig;
    tableColumnDefs: ColumnDef[];
    associateType: string;

    constructor(
        private i18n: I18nService,
        public str: HostsStrService,
        public utilService: UtilService,
        public injector: Injector) {
        super(injector);
    }

    ngOnInit(): void {
        this.associateType = `${this.i18n.get('common.hosts_title')}/${this.i18n.get('common.hostGroups_title')}`;
        super.ngOnInit();
    }

    initBtns(): void {
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'TYPE',
                header: this.i18n.get('common.type_column'),
                filterType: 'dropdown',
                options: this.str.initiatorTypeOptions,
                render: (data, col) => this.utilService.getLabelFromOptions(col.options as SelectOption[], data),
            },
            {
                field: 'RUNNINGSTATUS',
                header: this.i18n.get('common.status_column'),
                filterType: 'dropdown',
                options: {
                    0: this.i18n.get('common.EnumDefine_RUNNING_STATUS_E_UNKNOWN'),
                    27: this.i18n.get('common.EnumDefine_RUNNING_STATUS_E_ONLINE'),
                    28: this.i18n.get('common.EnumDefine_RUNNING_STATUS_E_OFFLINE'),
                },
                render: (data, col) => col.options[data],
            },
            {
                field: 'NAME',
                header: this.i18n.get('common.alias_lab'),
                sortable: true,
                render: (value) => value || UNPLACEHOLDER,
            },
            {
                field: 'ID',
                header: this.i18n.get(SWITCH.IS_DIRECT_MODE ? 'common.NQN_lab' : 'common.WWPNorIQNorNQN_lab'),
                filterType: 'search',
                sortable: true,
                render: (value: any) => this.utilService.decodeHTML(value),
                filterFn: (condition: string, data: any) => data.ID.includes(this.utilService.encodeHTML(condition)),
            },
        ];
        this.tableConfig = {
            dataKey: 'type_id',
            motion: false,
            rows: 5,
            beforeShow: (data) => data.map((item) => ({
                ...item,
                type_id: `${item.TYPE}_${item.ID}`,
            })),
        };
    }
}
